<template>
  <div class="repeatability props-group">
    <el-form-item label="重复性校验">
      <el-checkbox v-model="component.properties.repeatability"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-repeatability',
  props: ['component']
}
</script>

<style>
  .repeatability{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/repeatability.vue